import { ImageConfig } from '@teamfoster/sdk/image/src/models/image-config.model';

export const ImageSettings: Partial<ImageConfig> = {
  placeholderUrl: '/media/hedon-placeholder.png',
  defaultFormat: 'webp',
};
